export interface AlertHighlightContext {
  /** Whether the operator switched this alert on at all. */
  isEnabled: boolean;
  /** The configured limit. Zero or less means unconfigured. */
  threshold: number;
  /** The rolling window the sweep evaluates the alert over. */
  alertWindowHours: number;
  /** The window the tab is currently showing. */
  windowHours: number;
}

/**
 * The limit a value on screen may be marked against, or null for no marking.
 *
 * `ops-sweep.ts` evaluates every window alert over `tokenSpendAlertWindowHours`,
 * while the tab's range picker moves independently. A tenant past the per-tenant
 * limit on a seven-day view has not tripped a one-hour alert, so marking it
 * would claim an alert that never fired — and an operator who chases it finds
 * nothing in Slack. Matching the windows is therefore the condition for saying
 * anything at all, not a refinement of it.
 */
export function alertThresholdForWindow({
  isEnabled,
  threshold,
  alertWindowHours,
  windowHours,
}: AlertHighlightContext): number | null {
  if (!isEnabled || threshold <= 0) return null;
  if (alertWindowHours !== windowHours) return null;
  return threshold;
}
